import {
  getDecryptID,
  isEmptyObject,
  formatDigits,
  customParse,
  calculatePayFix,
  isString,
  calculatePromoGetItems,
  calculateRevBasedTax
} from './GlobalMethods'
import {
  getProductPromotion,
  calculatePromotion
} from './PBookPromotionsMethod'
import { SellProductJsonBuilder } from './SellScreenMethods'
import { clusterCalculations, calculateSaveEntireAmount } from './GlobalMethods'
import { loadPromoPrompt, loadTotalSaving } from './MainSale'
import { PROD_SEARCH_ENTITIES } from '../../constants/ProductSearch'

export function priceBookEffects (priceBooks, selectedCustomer) {
  const data = {
    isPriceBookApplied: false,
    selectedPriceBook: {}
  }

  if (
    priceBooks.filter(x => getDecryptID(x.customerGroupID) == '0')[0] !=
    undefined
  ) {
    data.selectedPriceBook = priceBooks.filter(
      x => getDecryptID(x.customerGroupID) == '0'
    )[0]
    data.isPriceBookApplied = true
  } else if (
    priceBooks.filter(
      x =>
        getDecryptID(x.customerGroupID) ==
        getDecryptID(selectedCustomer.customerGroupId)
    )[0] != undefined &&
    priceBooks.filter(
      x =>
        getDecryptID(x.customerGroupID) ==
        getDecryptID(selectedCustomer.customerGroupId)
    )[0].customerGroupID != undefined
  ) {
    data.selectedPriceBook = priceBooks.filter(
      x =>
        getDecryptID(x.customerGroupID) ==
        getDecryptID(selectedCustomer.customerGroupId)
    )[0]
    data.isPriceBookApplied = true
  } else {
    data.selectedPriceBook = {}
    data.isPriceBookApplied = false
  }

  return data
}

export function prodTaxHelper (items, basePrice, displayQuantity) {
  const data = {
    taxComponents: [],
    items: {}
  }

  if (items.sSalesOrderID != '') {
    if (
      items.productSellTaxes &&
      !isEmptyObject(items.productSellTaxes) &&
      items.productSellTaxes.length > 0
    ) {
      data.taxComponents = items.productSellTaxes.map(prodTax => {
        return {
          isFix: prodTax.isFix ? prodTax.isFix : false,
          salesOrderItemTaxID: prodTax.sSalesOrderItemTaxID,
          sSalesOrderID: prodTax.sSalesOrderID,
          sSalesOrderItemID: prodTax.sSalesOrderItemID,
          base_total_tax: prodTax.isFix
            ? displayQuantity * prodTax.taxValue
            : basePrice * displayQuantity * (prodTax.taxValue / 100),
          taxName: prodTax.saleTaxName,
          taxRate: prodTax.isFix ? 0 : prodTax.taxValue / 100,
          fixRate: prodTax.isFix ? prodTax.taxValue : 0,
          taxId: prodTax.sTaxID,
          total_tax: prodTax.taxPrice,
          indexKey: prodTax.indexKey ? prodTax.indexKey : '',
          taxCode: prodTax.taxCode ? prodTax.taxCode : ''
        }
      })
      items.taxComponents = data.taxComponents
    } else {
      data.taxComponents = items.taxComponents
    }
  } else {
    if (items.taxesRevisionList && items.taxesRevisionList.length > 0) {
      items.taxComponents = items.taxesRevisionList.map(a => {
        return {
          isFix: a.isFix,
          base_total_tax: a.isFix
            ? displayQuantity * a.value
            : basePrice * displayQuantity * (a.value / 100),
          taxName: a.name,
          taxRate: a.isFix ? 0 : a.value / 100,
          fixRate: a.isFix ? a.value : 0,
          taxId: a.taxID,
          total_tax: a.isFix
            ? a.value * displayQuantity
            : basePrice * displayQuantity * (a.value / 100),
          indexKey: a.indexKey ? a.indexKey : '',
          taxCode: a.taxCode ? a.taxCode : ''
        }
      })
      data.taxComponents = items.taxComponents
    }
    // if (items.tax_id != "" && (items.taxName != "") & (items.baseTax != "") && items.tax_id &&
    //     items.taxName && items.baseTax) {
    //     items.taxComponents = [
    //         {
    //             isFix: false,
    //             base_total_tax: basePrice * displayQuantity * (items.baseTax / 100),
    //             taxName: items.taxName,
    //             taxRate: items.baseTax / 100,
    //             taxId: items.tax_id,
    //             total_tax: basePrice * displayQuantity * (items.baseTax / 100),
    //         },
    //     ];
    //     data.taxComponents = items.taxComponents;
    // }
    else {
      data.taxComponents = items.taxComponents
    }
  }

  data.items = items
  return data
}

export function bestPriceSelection (
  isAdjustedPrice,
  isPriceBookApplied,
  selectedPriceBook,
  bestBasePrice,
  basePrice,
  totalTaxPercentageValue,
  displayPrice,
  totalTaxFixValue
) {
  const data = {
    bestBasePrice: 0
  }

  if (isAdjustedPrice) {
    if (isPriceBookApplied) {
      //&& !isRowDataPoke
      if (selectedPriceBook && selectedPriceBook.unitPrice) {
        const taxAmount = calculateRevBasedTax(
          totalTaxPercentageValue,
          totalTaxFixValue,
          selectedPriceBook.unitPrice
        )
        bestBasePrice = displayPrice - taxAmount
      } else {
        const taxAmounit = calculateRevBasedTax(
          totalTaxPercentageValue,
          totalTaxFixValue,
          basePrice
        )
        bestBasePrice = displayPrice - taxAmounit
      }
    }
  } else {
    if (isPriceBookApplied) {
      if (selectedPriceBook && selectedPriceBook.unitPrice) {
        bestBasePrice = selectedPriceBook.unitPrice
      }
    } else {
      bestBasePrice = basePrice
    }
  }
  data.bestBasePrice = bestBasePrice ? bestBasePrice : 0
  return data
}

export function promotionHelper (
  appliedPromotionObject,
  promotionDataByProductID,
  referencePromotion,
  items,
  promotionObject,
  isPromotionApplied,
  selectedCustomer,
  bestPriceBookInfo,
  grandTotalQuantity,
  isRowDataPoke,
  getStoredPromos,
  getSalePromoCode,
  getReduxSaleProductJsonData,
  displayQuantity,
  productRowKey,
  builderType,
  getCustomerSearchData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getDefaultDecimalPlaces,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getIsRefundSale,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getRefundKeys,
  getSalePayments,
  dispatch,
  isRefund,
  isOnAccount,
  getSavings,
  totalTaxFixValue,
  attribProps
) {
  let preparedData = {
    appliedPromotionObject: {},
    promotionDataByProductID: {},
    referencePromotion: {},
    promotionObject: {},
    isPromotionApplied: false
  }
  const priceFinal = getIsTaxExclusive
    ? bestPriceBookInfo.price
    : bestPriceBookInfo.price +
      (bestPriceBookInfo.tax - (totalTaxFixValue ? totalTaxFixValue : 0))
  //helper method extension
  if (items.promotions && items.promotions.length > 0) {
    let dbPromo = items.promotions[0]
    if (dbPromo.promoJSON && dbPromo.promoJSON != '') {
      let parsedJson = JSON.parse(dbPromo.promoJSON)
      promotionObject = parsedJson.appliedPromoClone
      promotionObject.isExistingPromotion = true
    }
  }
  if (promotionObject != undefined && !isEmptyObject(promotionObject)) {
    if (
      items &&
      items.PromotionandPriceBookDetails &&
      !isEmptyObject(items.PromotionandPriceBookDetails.ReferencePromotion)
    ) {
      referencePromotion = {
        ...items.PromotionandPriceBookDetails.ReferencePromotion
      }
    }
    if (promotionObject.isExistingPromotion) {
      appliedPromotionObject = promotionObject
      isPromotionApplied = true
    } else if (
      promotionObject &&
      !isEmptyObject(promotionObject) &&
      promotionObject.finish
    ) {
      isPromotionApplied = false
      appliedPromotionObject = {}
      promotionObject = {}
    }
  } else {
    let cussGroupID =
      selectedCustomer && selectedCustomer.customerGroupId
        ? selectedCustomer.customerGroupId
        : ''
    let bestPricePromo = priceFinal * grandTotalQuantity
    let bestPricePromoRow = priceFinal * displayQuantity
    let calculatedPromo = {}
    if (!isRowDataPoke && !isRefund && !isOnAccount) {
      promotionDataByProductID = getProductPromotion(
        items.sProductID, //prodid
        getStoredPromos, // promo list
        bestPricePromo, // amount
        grandTotalQuantity, // quantity
        cussGroupID,
        getSalePromoCode, //promo code
        getReduxSaleProductJsonData,
        bestPricePromoRow,
        !isEmptyObject(items.identityInfo) ? items.identityInfo : {}
      )
      calculatedPromo = calculatePromotion(
        items,
        getReduxSaleProductJsonData,
        promotionDataByProductID,
        displayQuantity,
        grandTotalQuantity,
        productRowKey,
        referencePromotion,
        bestPriceBookInfo,
        builderType,
        getCustomerSearchData,
        getStoredBooks,
        getIsLoyaltyEnabled,
        getDefaultLoyaltyAmount,
        getIsTaxExclusive,
        getStoredPromos,
        getDefaultDecimalPlaces,
        getSelectedOutlet,
        getSelectedReg,
        getBasicIsPercent,
        getIsRefundSale,
        getCurrentSalesOrderData,
        getCurrentSalesOrderStatusID,
        formDiscountPrice,
        formDiscountPercentage,
        formSellNotes,
        appliedPromotionObject,
        isPromotionApplied,
        getRefundKeys,
        getSalePayments,
        dispatch,
        getSavings,
        attribProps
      )
    }
    if (calculatedPromo && !isEmptyObject(calculatedPromo)) {
      if (calculatedPromo.isEnd) {
        return
      } else {
        appliedPromotionObject = calculatedPromo.appliedObj
        isPromotionApplied = calculatedPromo.appliedObj
          ? calculatedPromo.isApplied
          : false
        referencePromotion = { ...calculatedPromo.refPromo }
      }
    }
  }

  //Old Promotio Work Here -- Shifted to notepad++ new14

  preparedData.appliedPromotionObject = appliedPromotionObject
  preparedData.isPromotionApplied = isPromotionApplied
  preparedData.referencePromotion = referencePromotion
  preparedData.promotionObject = promotionObject
  preparedData.promotionDataByProductID = promotionDataByProductID
  return preparedData
}

export function promoPriceEffect (
  priceDisplay,
  appliedPromotionObject,
  PromotionandPriceBookDetails,
  bestPriceBookInfo,
  displayQuantity,
  getIsTaxExclusive
) {
  const data = {
    priceDisplay: 0,
    bestUnit: 0
  }

  const price = getIsTaxExclusive
    ? bestPriceBookInfo.price
    : bestPriceBookInfo.price + bestPriceBookInfo.tax
  data.bestUnit = !getIsTaxExclusive ? bestPriceBookInfo.price : 0
  // if (appliedPromotionObject.isPayFix) {
  //     priceDisplay = PromotionandPriceBookDetails.lineItemPromotions.promotionPrice;
  // }
  // else
  if (
    appliedPromotionObject.isPayFix ||
    appliedPromotionObject.isOffEntireSale ||
    appliedPromotionObject.isGetItem
  ) {
    //entire sale && discount getItem && appliedPromotionObject.isGetFree
    priceDisplay = price
    priceDisplay -=
      PromotionandPriceBookDetails.lineItemPromotions.promotionPrice /
      displayQuantity
  } else {
    priceDisplay =
      price -
      PromotionandPriceBookDetails.lineItemPromotions.promotionPrice /
        displayQuantity
  }

  data.priceDisplay = priceDisplay
  return data
}

export function promoProdEffect (
  callIdentity,
  prod,
  promoForProds,
  builderType,
  getCustomerSearchData,
  getReduxSaleProductJsonData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getStoredPromos,
  getDefaultDecimalPlaces,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getIsRefundSale,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getRefundKeys,
  getSalePayments,
  dispatch,
  getSavings,
  attribProps
) {
  let prodsss = getReduxSaleProductJsonData
  const productsClone = SellProductJsonBuilder(
    prod,
    promoForProds,
    builderType,
    getCustomerSearchData,
    getReduxSaleProductJsonData,
    getStoredBooks,
    getIsLoyaltyEnabled,
    getDefaultLoyaltyAmount,
    getIsTaxExclusive,
    getStoredPromos,
    getDefaultDecimalPlaces,
    getSelectedOutlet,
    getSelectedReg,
    getBasicIsPercent,
    getIsRefundSale,
    getCurrentSalesOrderData,
    getCurrentSalesOrderStatusID,
    formDiscountPrice,
    formDiscountPercentage,
    formSellNotes,
    getRefundKeys,
    getSalePayments,
    dispatch,
    false,
    getSavings,
    'promoProdEffect',
    false,
    attribProps
  )
  if (productsClone && !isEmptyObject(productsClone)) {
    if (
      productsClone.key &&
      prodsss.filter(a => a.key === productsClone.key)[0]
    ) {
      let index = prodsss.indexOf(
        prodsss.filter(a => a.key == productsClone.key)[0]
      )
      prodsss[index] = productsClone
    } else {
      prodsss = prodsss.concat(productsClone)
    }
  }
  clusterCalculations(
    prodsss,
    getSelectedOutlet,
    getSelectedReg,
    getBasicIsPercent,
    getCustomerSearchData,
    getIsRefundSale,
    getDefaultDecimalPlaces,
    getCurrentSalesOrderData,
    getCurrentSalesOrderStatusID,
    formDiscountPrice,
    formDiscountPercentage,
    formSellNotes,
    getRefundKeys,
    getSalePayments,
    dispatch,
    getStoredPromos,
    getIsTaxExclusive,
    false,
    getSavings,
    attribProps
  )
}

export function promoProductsEffect (
  callIdentity,
  mapProdList,
  appliedPromotionObject,
  builderType,
  getCustomerSearchData,
  items, //getReduxSaleProductJsonData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getStoredPromos,
  getDefaultDecimalPlaces,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getIsRefundSale,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getRefundKeys,
  getSalePayments,
  dispatch,
  extraProd, // check ref sent prod
  promotionDataByProductID, // if req
  nominatedPromo, // if req
  getSavings,
  bestPriceBookInfo,
  incomingProd,
  attribProps
) {
  let sProducts = items
  let finish = false
  const promoValue = appliedPromotionObject.getAmount
    ? appliedPromotionObject.getAmount
    : 0
  const promoDiscount = appliedPromotionObject.discountPercentage
    ? appliedPromotionObject.discountPercentage
    : 0
  const buyValue = appliedPromotionObject.buyTotal
    ? appliedPromotionObject.buyTotal
    : 0
  const fixPriceValue = appliedPromotionObject.fixPriceTotal
    ? appliedPromotionObject.fixPriceTotal
    : 0
  const toApplyPromo = { ...appliedPromotionObject }
  mapProdList.map((item, keyy) => {
    let promoApply = { ...toApplyPromo }
    const priceItem = getIsTaxExclusive
      ? item.bestPriceBookInfo.price
      : item.bestPriceBookInfo.price + item.bestPriceBookInfo.tax
    if (callIdentity == 'certainAmountPercent') {
      promoApply.amount =
        ((priceItem * item.displayQuantity) / 100) *
        promotionDataByProductID.discountPercentage
      promoApply.isExistingPromotion = true
    } else if (callIdentity == 'entireSaleOffRemove') {
      if (extraProd.key && item.key == extraProd.key) {
        item = extraProd
      }
    } else if (callIdentity == 'entireOffPercent') {
      promoApply.amount =
        ((priceItem * item.displayQuantity) / 100) *
        nominatedPromo.discountPercentage
      promoApply.isExistingPromotion = true
    } else if (callIdentity == 'getItemRemove') {
      if (extraProd.key && item.key && item.key == extraProd.key) {
        item = extraProd
      }
    } else if (callIdentity == 'certainAmountCash') {
      const priceDeduct = calculateSaveEntireAmount(
        incomingProd,
        mapProdList,
        promoValue,
        bestPriceBookInfo,
        item.bestPriceBookInfo && item.bestPriceBookInfo.price
          ? item.bestPriceBookInfo.price * item.displayQuantity
          : 0
      )
      promoApply.amount = priceDeduct
    } else if (callIdentity == 'payFix') {
      const fixPriceDeduct = calculatePayFix(
        mapProdList,
        bestPriceBookInfo,
        getIsTaxExclusive,
        buyValue,
        fixPriceValue,
        item.promoIndex != undefined && item.promoIndex != null
          ? item.promoIndex
          : keyy
      )
      if (fixPriceDeduct) {
        promoApply.amount = fixPriceDeduct
      } else {
        finish = true
      }
    } else if (
      callIdentity &&
      isString(callIdentity) &&
      callIdentity.includes('getItems_')
    ) {
      let getPriceDeduct = false
      if (item.promoQuantity) {
        getPriceDeduct = calculatePromoGetItems(
          callIdentity,
          priceItem,
          promoDiscount,
          promoValue,
          item.displayQuantity,
          item.promoQuantity
        )
      }
      if (getPriceDeduct) {
        promoApply.amount = getPriceDeduct
      } else {
        finish = true
      }
    } else if (callIdentity == 'toRemovePromo') {
      finish = true
    }
    const productsClone = SellProductJsonBuilder(
      item,
      finish ? { finish: true } : promoApply,
      builderType,
      getCustomerSearchData,
      items, //getReduxSaleProductJsonData,
      getStoredBooks,
      getIsLoyaltyEnabled,
      getDefaultLoyaltyAmount,
      getIsTaxExclusive,
      getStoredPromos,
      getDefaultDecimalPlaces,
      getSelectedOutlet,
      getSelectedReg,
      getBasicIsPercent,
      getIsRefundSale,
      getCurrentSalesOrderData,
      getCurrentSalesOrderStatusID,
      formDiscountPrice,
      formDiscountPercentage,
      formSellNotes,
      getRefundKeys,
      getSalePayments,
      dispatch,
      false,
      getSavings,
      'promoProductsEffect',
      false,
      attribProps
    )
    if (productsClone && !isEmptyObject(productsClone)) {
      if (
        productsClone.key &&
        sProducts.filter(a => a.key === productsClone.key)[0]
      ) {
        let index = sProducts.indexOf(
          sProducts.filter(a => a.key == productsClone.key)[0]
        )
        sProducts[index] = productsClone
      } else {
        sProducts = sProducts.concat(productsClone)
      }
    }
  })
  clusterCalculations(
    sProducts,
    getSelectedOutlet,
    getSelectedReg,
    getBasicIsPercent,
    getCustomerSearchData,
    getIsRefundSale,
    getDefaultDecimalPlaces,
    getCurrentSalesOrderData,
    getCurrentSalesOrderStatusID,
    formDiscountPrice,
    formDiscountPercentage,
    formSellNotes,
    getRefundKeys,
    getSalePayments,
    dispatch,
    getStoredPromos,
    getIsTaxExclusive,
    false,
    getSavings,
    attribProps
  )
}

export function isProdInCondition (prodid, buyProds) {
  let exist = false
  if (buyProds && buyProds.length > 0) {
    exist =
      buyProds.filter(ee => getDecryptID(ee.productID) == getDecryptID(prodid))
        .length > 0
        ? true
        : false
  }
  return exist
}

export function getBuyCount (prodList, buyProds, currProd, buyCount) {
  let count = 0
  let cartBuyProds = []
  prodList.map(a => {
    const data = buyProds.filter(
      ee => getDecryptID(ee.productID) == getDecryptID(a.sProductID)
    )
    if (data && data.length > 0) {
      cartBuyProds.push(a)
    }
  })

  if (cartBuyProds && cartBuyProds.length > 0) {
    let cartBuyCount = 0 // except rewardprod
    if (currProd.key) {
      cartBuyProds
        .filter(qw => qw.key != currProd.key)
        .map(er => {
          cartBuyCount += er.displayQuantity
        })
    } else {
      cartBuyProds
        .filter(
          qw => getDecryptID(qw.sProductID) != getDecryptID(currProd.sProductID)
        )
        .map(er => {
          cartBuyCount += er.displayQuantity
        })
    }

    if (cartBuyCount >= buyCount) {
      count = currProd.displayQuantity
    } else if (cartBuyCount < buyCount) {
      let supposed = currProd.displayQuantity
      for (let i = 1; i == currProd.displayQuantity; i++) {
        cartBuyCount += i
        supposed -= i
        if (cartBuyCount == buyCount) {
          count = supposed
          break
        }
      }
    }
  }

  return count > 0 ? count : 0
}

export function getSpendCount (prodList, spentProd, currProd, promoInfo) {
  const spentAmount = promoInfo.spendAmount
  const getQuantity = promoInfo.getQuantity
  const getAmount = promoInfo.amount
  const isGetAmount = promoInfo.isGetAmount
  const discountPer = promoInfo.discountPercentage
  let count = 0
  let cartSpentProds = []
  prodList.map(a => {
    const data = spentProd.filter(
      ee => getDecryptID(ee.productID) == getDecryptID(a.sProductID)
    )
    if (data && data.length > 0) {
      cartSpentProds.push(a)
    }
  })

  if (cartSpentProds && cartSpentProds.length > 0) {
    let cartSpentAmount = 0 // except rewardprod
    if (currProd.key) {
      cartSpentProds
        .filter(qw => qw.key != currProd.key)
        .map(er => {
          cartSpentAmount += er.basePrice * er.displayQuantity
        })
    } else {
      cartSpentProds
        .filter(
          qw => getDecryptID(qw.sProductID) != getDecryptID(currProd.sProductID)
        )
        .map(er => {
          cartSpentAmount += er.basePrice * er.displayQuantity
        })
    }

    const checkAmount = checkAmountSpent(
      cartSpentAmount,
      getAmount,
      getQuantity,
      isGetAmount,
      discountPer
    )
    if (checkAmount >= spentAmount) {
      count = currProd.displayQuantity
    } else if (checkAmount < spentAmount) {
      let supposed = currProd.displayQuantity
      for (let i = 1; i < currProd.displayQuantity; i++) {
        cartSpentAmount += currProd.basePrice * i
        const newCheck = checkAmountSpent(
          cartSpentAmount,
          getAmount,
          getQuantity,
          isGetAmount,
          discountPer
        )
        supposed -= i
        if (newCheck >= spentAmount) {
          count = supposed
          break
        }
      }
    }
  }

  return count > 0 ? count : 0
}

function checkAmountSpent (
  spent,
  getAmount,
  getQuantity,
  isGetAmount,
  discountPer
) {
  const percent = discountPer * getQuantity
  const calculated = isGetAmount
    ? getAmount * getQuantity
    : spent * (percent / 100)
  const amount = spent - calculated
  return amount
}

export function checkPromoPrompt (
  prodList,
  promoList,
  customerGroupID,
  dispatch
) {
  const cusGroupID =
    customerGroupID && customerGroupID.includes('&')
      ? customerGroupID.substring(0, customerGroupID.indexOf('&'))
      : false
  if (prodList && promoList && prodList.length > 0 && promoList.length > 0) {
    let isPromoApplied = false
    prodList.map(xxc => {
      if (xxc.isPromotionApplied) {
        isPromoApplied = true
        dispatch(loadPromoPrompt({}))
        return
      }
    })

    if (!isPromoApplied) {
      const advBuyList = promoList.filter(er => er.isAdvanceBuy)
      advBuyList.map(qw => {
        //identify the target
        let isTargetExist = false
        if (!qw.isEveryone) {
          if (
            cusGroupID &&
            qw.promoCustomerGroup &&
            qw.promoCustomerGroup.length > 0
          ) {
            let customerExist = qw.promoCustomerGroup.filter(
              a =>
                a.sCustomerGroupID.substring(
                  0,
                  a.sCustomerGroupID.indexOf('&')
                ) == cusGroupID
            )
            if (customerExist.length > 0) {
              isTargetExist = true
            }
          }
        } else if (qw.isEveryone) {
          isTargetExist = true
        }

        if (isTargetExist) {
          prodList.map(ddf => {
            if (qw.promoProducts && qw.promoProducts.length > 0) {
              const isPresent = qw.promoProducts.filter(
                ssd =>
                  getDecryptID(ssd.productID) == getDecryptID(ddf.sProductID)
              )
              if (isPresent && isPresent.length > 0) {
                if (isPresent[0].isInclude) {
                  dispatch(loadPromoPrompt(qw))
                  return
                }
              }
            }
          })
        }
      })

      // if (isTargetExist) {
      //     if (advBuyList && advBuyList.length > 0) {
      //         prodList.map(ddf => {
      //             advBuyList.map(mml => {
      //                 if (mml.promoProducts && mml.promoProducts.length > 0) {
      //                     const isPresent = mml.promoProducts.filter(ssd => getDecryptID(ssd.productID) == getDecryptID(ddf.sProductID));
      //                     if (isPresent && isPresent.length > 0) {
      //                         if (isPresent[0].isInclude) {
      //                             dispatch(loadPromoPrompt(mml));
      //                             return;
      //                         }
      //                     }
      //                 }
      //             });
      //         });
      //     }
      // }
    }
  }
}

export function calculateSavings (
  prods,
  getTableDataSellPromotion,
  getDiscountPriceTotal,
  getDefaultDecimalPlaces,
  isRefundSale,
  dispatch
) {
  let prodDisc = 0
  let prodPBValue = 0
  prods &&
    prods.length > 0 &&
    prods.map(qw => {
      if (qw.isRowDataPoke) {
        prodDisc +=
          qw.displayDiscount && qw.displayDiscount > 0 ? qw.displayDiscount : 0
      }
      if (qw.isPriceBookApplied) {
        prodPBValue +=
          qw.PromotionandPriceBookDetails &&
          qw.PromotionandPriceBookDetails.pricebookValue
            ? customParse(qw.PromotionandPriceBookDetails.pricebookValue)
            : 0
      }
    })
  const promoSavings =
    getTableDataSellPromotion && getTableDataSellPromotion != undefined
      ? customParse(
          getTableDataSellPromotion.reduce(
            (a, v) => (a = a + v.promotionAmount),
            0
          )
        )
      : 0
  const savings = isRefundSale
    ? 0
    : (promoSavings < 0 ? promoSavings * -1 : promoSavings) +
      customParse(getDiscountPriceTotal ? getDiscountPriceTotal : 0) +
      customParse(prodDisc ? (prodDisc < 0 ? 0 : prodDisc) : 0) +
      customParse(
        prodPBValue ? (prodPBValue < 0 ? prodPBValue * -1 : prodPBValue) : 0
      )
  if (savings > 0) {
    const savingString = formatDigits(savings, getDefaultDecimalPlaces)
    dispatch(loadTotalSaving(savingString))
  } else {
    dispatch(loadTotalSaving(''))
  }
}

export function calculateExplicitDisc (prod, discount, taxExc) {
  let result = {
    item: {}
  }
  prod.isPromotionApplied = false
  prod.isPriceBookApplied = false
  // prod.isPriceAdjusted = true;
  prod.discountPoked = true

  const discApplyPrice =
    prod.totals.displayBasePrice -
    (taxExc ? 0 : prod.totalTaxFixValue ? prod.totalTaxFixValue : 0)
  prod.displayDiscount = (discApplyPrice * discount) / 100
  prod.displayDiscountPercent = customParse(discount)
  prod.displayMarkupPercent = discount
  prod.discountIsPercentage = true
  prod.displayPrice = prod.totals.displayBasePrice - prod.displayDiscount
  // prod.displayPrice /= prod.displayQuantity;
  //empty promo
  if (
    prod.PromotionandPriceBookDetails &&
    !isEmptyObject(prod.PromotionandPriceBookDetails)
  ) {
    if (prod.PromotionandPriceBookDetails.ReferencprodePromotion) {
      prod.PromotionandPriceBookDetails.ReferencePromotion = {}
    }
    if (prod.PromotionandPriceBookDetails.lineItemPromotions) {
      prod.PromotionandPriceBookDetails.lineItemPromotions = {}
    }
    if (prod.PromotionandPriceBookDetails.AppliedPromotionDetails) {
      prod.PromotionandPriceBookDetails.AppliedPromotionDetails = []
    }
    if (prod.PromotionandPriceBookDetails.price_book_id) {
      prod.PromotionandPriceBookDetails.price_book_id = ''
    }
    if (prod.PromotionandPriceBookDetails.pricebookValue) {
      prod.PromotionandPriceBookDetails.pricebookValue = 0
    }
  }
  if (prod.priceBooks) {
    prod.priceBooks = []
  }

  result.item = prod
  return result
}

export function calculateExplicitPrice (prod, price, taxExc) {
  let result = {
    item: {}
  }
  prod.displayPrice = !price
    ? 0
    : price
    ? customParse(price) * prod.displayQuantity +
      (taxExc ? 0 : prod.totalTaxFixValue * prod.displayQuantity)
    : prod.displayPrice
  prod.isPromotionApplied = false
  prod.isPriceBookApplied = false
  prod.isPriceAdjusted = true
  // prod.displayDiscount = prod.totals.displayBasePrice - item.displayPrice;
  // prod.displayDiscountPercent = (prod.displayDiscount / prod.totals.displayBasePrice) * 100;
  // prod.displayMarkupPercent = (prod.displayDiscount / prod.totals.displayBasePrice) * 100;

  prod.displayDiscount = prod.displayDiscount + '_ROWPOKED'
  if (
    prod.PromotionandPriceBookDetails &&
    !isEmptyObject(prod.PromotionandPriceBookDetails)
  ) {
    if (prod.PromotionandPriceBookDetails.ReferencePromotion) {
      prod.PromotionandPriceBookDetails.ReferencePromotion = {}
    }
    if (prod.PromotionandPriceBookDetails.lineItemPromotions) {
      prod.PromotionandPriceBookDetails.lineItemPromotions = {}
    }
    if (prod.PromotionandPriceBookDetails.AppliedPromotionDetails) {
      prod.PromotionandPriceBookDetails.AppliedPromotionDetails = []
    }
    if (prod.PromotionandPriceBookDetails.price_book_id) {
      prod.PromotionandPriceBookDetails.price_book_id = ''
    }
    if (prod.PromotionandPriceBookDetails.pricebookValue) {
      prod.PromotionandPriceBookDetails.pricebookValue = 0
    }
  }
  if (prod.priceBooks) {
    prod.priceBooks = []
  }

  result.item = prod
  return result
}

export function calculateExplicitQuantity (prod, quantity, isExc) {
  let result = {
    item: {}
  }

  const priceExc =
    prod.totals && prod.totals.exclusivePrice
      ? prod.totals.exclusivePrice / prod.displayQuantity
      : 0
  const priceInc =
    prod.totals && prod.totals.inclusivePrice
      ? prod.totals.inclusivePrice / prod.displayQuantity
      : 0
  const accPrice = isExc ? priceExc : priceInc
  prod.displayPrice = accPrice * quantity
  prod.displayQuantity = quantity

  result.item = prod
  return result
}

export function calculateRefundPrice (
  displayQuantity,
  items,
  getIsTaxExclusive,
  isOnAccount
) {
  let res = {
    price: 0,
    refundUnitPrice: 0,
    refundPromoApplied: items.refundPromoApplied,
    refundUnitPriceExc: items.refundUnitPriceExc,
    selectedPriceBook: items.selectedPriceBook,
    isPBApplied: items.isPriceBookApplied
  }
  let isQuantityZero = false
  let dispPrice = 0
  if (!items.firstTime) {
    // items.key
    res.refundUnitPrice = items.refundUnitPrice
    if (displayQuantity != 0) {
      dispPrice = items.refundUnitPrice * displayQuantity
      // if (displayQuantity > 0) {
      //     dispPrice *= -1;
      // }
    } else if (displayQuantity == 0) {
      isQuantityZero = 0
    }
  } else {
    // this else should be run only once for a prod
    res.refundUnitPriceExc = items.unitPrice / displayQuantity
    if (getIsTaxExclusive) {
      res.refundUnitPrice = items.unitPrice / displayQuantity
    } else {
      res.refundUnitPrice = items.totalPrice / displayQuantity
    }
    dispPrice = res.refundUnitPrice * displayQuantity
    if (items.promotions && !isEmptyObject(items.promotions)) {
      const promoValue =
        items.promotions.length > 0 && items.promotions[0].promotionValue
          ? items.promotions[0].promotionValue
          : 0
      if (promoValue) {
        res.refundPromoApplied =
          res.refundUnitPrice + promoValue / displayQuantity
      }
    }
    if (items.e_ProductPriceBookID && items.currentPriceBookValue) {
      res.selectedPriceBook = {
        priceBookID: items.e_ProductPriceBookID,
        price: items.currentPriceBookValue
      }
      res.isPBApplied = true
    }
  }
  res.price = isQuantityZero ? 0 : dispPrice

  return res
}

export function calculateDiscountPercent (
  getIsTaxExclusive,
  price,
  tax,
  discount
) {
  let discp = 0
  if (price) {
    if (getIsTaxExclusive) {
      discp = (discount / price) * 100
    } else {
      price += price * tax
      discp = (discount / price) * 100
    }
  }
  discp = discp < 0 ? discp * -1 : discp
  return discp ? discp : 0
}

export function promoProdReqInfo (promoProds, isExclude) {
  let result = {
    cat: [],
    brand: [],
    supplier: [],
    tags: [],
    skus: [],
    prod: []
  }
  if (promoProds && promoProds.length > 0) {
    promoProds.map(e => {
      if (
        e.productID &&
        e.isExclude == isExclude &&
        getDecryptID(e.productID) != '0'
      )
        result.prod.push(getDecryptID(e.productID))
      switch (e.entityID) {
        case PROD_SEARCH_ENTITIES.Search_By_Category: {
          if (e.rowID && e.isExclude == isExclude) result.cat.push(e.rowID)
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_Brand: {
          if (e.rowID && e.isExclude == isExclude) result.brand.push(e.rowID)
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
          if (e.rowID && e.isExclude == isExclude) result.supplier.push(e.rowID)
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_Tags: {
          if (e.rowID && e.isExclude == isExclude) result.tags.push(e.rowID)
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_SKUs: {
          if (e.rowID && e.isExclude == isExclude) result.skus.push(e.rowID)
          break
        }
        default: {
        }
      }
    })
  }
  return result
}

export function promoCheckProdSuccess (promoProducts, prodInfo, isExclude) {
  // // NOTE: RULES: if entity same then, any of the entity should be present in prod obj
  // // if entity diff then take list of cats, brands etc and check if prodobj exists in every list atleast one of em
  // // if prodid is coming that directly prod added then it will be successlly pass the prodObj and same as per the SKUid
  let result = false
  const promoHelper = promoProdReqInfo(promoProducts, isExclude)
  if (!isEmptyObject(promoHelper) && !isEmptyObject(prodInfo)) {
    if (promoHelper.prod && promoHelper.prod.length > 0) {
      if (prodInfo.prod) {
        const dd = promoHelper.prod.filter(wq => prodInfo.prod == wq)
        if (dd && dd.length > 0) {
          result = true
        }
      }
    }
    if (!result && promoHelper.skus && promoHelper.skus.length > 0) {
      if (prodInfo.skus && prodInfo.skus.length > 0) {
        const dd = prodInfo.skus.some(ee => promoHelper.skus.includes(ee))
        if (dd) {
          result = true
        }
      }
    }
    if (!result) {
      let entitiesValues = {
        cat: [],
        brand: [],
        tags: [],
        supplier: []
      }
      if (promoHelper.cat) {
        entitiesValues.cat = promoHelper.cat
        // promoHelper.cat.map(a => entitiesValues.cat.push(a))
      }
      if (promoHelper.brand) {
        entitiesValues.brand = promoHelper.brand
        // promoHelper.brand.map(a => entitiesValues.brand.push(a))
      }
      if (promoHelper.tags) {
        entitiesValues.tags = promoHelper.tags
        // promoHelper.tags.map(a => entitiesValues.tags.push(a))
      }
      if (promoHelper.supplier) {
        entitiesValues.supplier = promoHelper.supplier
        // promoHelper.supplier.map(a => entitiesValues.supplier.push(a))
      }
      const filledArrays = Object.entries(entitiesValues).filter(
        ([key, value]) => value.length > 0
      )
      if (
        entitiesValues.cat.length > 0 ||
        entitiesValues.brand.length > 0 ||
        entitiesValues.tags.length > 0 ||
        entitiesValues.supplier.length > 0
      ) {
        let allowed = true
        for (let [key, values] of filledArrays) {
          switch (key) {
            case 'cat':
              if (!values.includes(prodInfo.category)) {
                allowed = false
              }
              break
            case 'brand':
              if (!values.includes(prodInfo.brand)) {
                allowed = false
              }
              break
            case 'tags':
              if (!prodInfo.tags.some(tag => values.includes(tag))) {
                allowed = false
              }
              break
            case 'supplier':
              if (!values.includes(prodInfo.supplier)) {
                allowed = false
              }
              break
            default:
              break
          }
        }
        result = allowed
      }
    }
  }
  return result
}

// export function promoasdasdSuccess (promoHelper, prodInfo) {
//   // // NOTE: RULES: if entity same then, any of the entity should be present in prod obj
//   // // if entity diff then take list of cats, brands etc and check if prodobj exists in every list atleast one of em
//   // // if prodid is coming that directly prod added then it will be successlly pass the prodObj and same as per the SKUid

//   let result = false

//   //////////

// //   const promoHelper = {
// //     cat: [1, 2, 3],
// //     brand: [4, 5],
// //     tags: [6, 7, 8],
// //     supplier: [],
// //     skus: [1009, 10088],
// //     prod: [2, 4, 22]
// //   }

// //   const prodInfo = {
// //     prod: 1,
// //     category: 2,
// //     brand: 5,
// //     supplier: null,
// //     tags: [7, 10],
// //     skus: [1005, 1006]
// //   }

//   ///////////

//   if (!isEmptyObject(promoHelper) && !isEmptyObject(prodInfo)) {
//     if (promoHelper.prod && promoHelper.prod.length > 0) {
//       if (prodInfo.prod) {
//         const dd = promoHelper.prod.filter(wq => prodInfo.prod == wq)
//         if (dd && dd.length > 0) {
//           result = true
//         }
//       }
//     }
//     if (!result && promoHelper.skus && promoHelper.skus.length > 0) {
//       if (prodInfo.skus && prodInfo.skus.length > 0) {
//         const dd = prodInfo.skus.some(ee => promoHelper.skus.includes(ee))
//         if (dd) {
//           result = true
//         }
//       }
//     }
//     if (!result) {
//       const filledArrays = Object.entries(promoHelper).filter(
//         ([key, value]) => value.length > 0
//       )
//       for (let [key, values] of filledArrays) {
//         switch (key) {
//           case 'cat':
//             if (!values.includes(prodInfo.category)) {
//               result = false
//               return result
//             }
//             break
//           case 'brand':
//             if (!values.includes(prodInfo.brand)) {
//               result = false
//               return result
//             }
//             break
//           case 'tags':
//             if (!prodInfo.tags.some(tag => values.includes(tag))) {
//               result = false
//               return result
//             }
//             break
//           case 'supplier':
//             if (!values.includes(prodInfo.supplier)) {
//               result = false
//               return result
//             }
//             break
//           default:
//             break
//         }
//       }
//       result = true
//     }
//   }
//   return result
// }
